import { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { supabase } from './lib/supabase';
import type { Session } from '@supabase/supabase-js';
import AppLayout from './components/AppLayout';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Home from './pages/home/Home';
import Bible from './pages/bible/Bible';
import BibleBook from './pages/bible/BibleBook';
import BibleChapter from './pages/bible/BibleChapter';
import BibleVerse from './pages/bible/BibleVerse';
import Events from './pages/events/Events';
import EventDetail from './pages/events/EventDetail';
import Studies from './pages/studies/Studies';
import StudyDetail from './pages/studies/StudyDetail';
import Preachings from './pages/preachings/Preachings';
import PreachingDetail from './pages/preachings/PreachingDetail';
import Prayers from './pages/prayers/Prayers';
import PrayerDetail from './pages/prayers/PrayerDetail';
import Songs from './pages/songs/Songs';
import SongDetail from './pages/songs/SongDetail';
import Playlists from './pages/music/Playlists';
import PlaylistDetail from './pages/music/PlaylistDetail';
import Dictionary from './pages/dictionary/Dictionary';
import DictionaryEntry from './pages/dictionary/DictionaryEntry';
import VerseOfWeek from './pages/verse/VerseOfWeek';
import Tickets from './pages/tickets/Tickets';
import TicketDetail from './pages/tickets/TicketDetail';
import Profile from './pages/profile/Profile';
import Settings from './pages/settings/Settings';

function App() {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-primary flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-white border-t-transparent"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={session ? <Navigate to="/" /> : <Login />} />
      <Route path="/register" element={session ? <Navigate to="/" /> : <Register />} />
      
      <Route element={<AppLayout />}>
        <Route path="/" element={<Home />} />
        
        <Route path="/verse" element={<VerseOfWeek />} />
        
        <Route path="/bible" element={<Bible />} />
        <Route path="/bible/:book" element={<BibleBook />} />
        <Route path="/bible/:book/:chapter" element={<BibleChapter />} />
        <Route path="/bible/:book/:chapter/:verse" element={<BibleVerse />} />
        
        <Route path="/events" element={<Events />} />
        <Route path="/events/:id" element={<EventDetail />} />
        
        <Route path="/studies" element={<Studies />} />
        <Route path="/studies/:id" element={<StudyDetail />} />
        
        <Route path="/preachings" element={<Preachings />} />
        <Route path="/preachings/:id" element={<PreachingDetail />} />
        
        <Route path="/prayers" element={<Prayers />} />
        <Route path="/prayers/:id" element={<PrayerDetail />} />
        
        <Route path="/songs" element={<Songs />} />
        <Route path="/songs/:id" element={<SongDetail />} />
        
        <Route path="/music" element={<Playlists />} />
        <Route path="/music/:id" element={<PlaylistDetail />} />
        
        <Route path="/dictionary" element={<Dictionary />} />
        <Route path="/dictionary/:id" element={<DictionaryEntry />} />
        
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/tickets/:id" element={<TicketDetail />} />
        
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

export default App;
